import { type ReactNode } from 'react';

export function ActionLabel({ busy, idle, working }: { busy: boolean; idle: ReactNode; working: ReactNode }) {
  return (
    <span className="action-label">
      <span className={busy ? 'action-label-hidden' : ''} aria-hidden={busy || undefined}>
        {idle}
      </span>
      <span className={!busy ? 'action-label-hidden' : ''} aria-hidden={!busy || undefined}>
        {working}
      </span>
    </span>
  );
}
